/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 require('./bootstrap');

 import Vue from 'vue/dist/vue';

 window.Vue = Vue;
 
 import VueScrollTo from 'vue-scrollto';
//  var VueScrollTo = require('vue-scrollto');
 
 Vue.use(VueScrollTo);
 
 // You can also pass in the default options
 Vue.use(VueScrollTo, {
      container: "body",
      duration: 500,
      easing: "ease",
      offset: 0,
      force: true,
      cancelable: true,
      onStart: false,
      onDone: false,
      onCancel: false,
      x: false,
      y: true
  });
 
 /**
  * The following block of code may be used to automatically register your
  * Vue components. It will recursively scan this directory for the Vue
  * components and automatically register them with their "basename".
  *
  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
  */
 
 // const files = require.context('./', true, /\.vue$/i)
 // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
 
//  Vue.component('example-component', require('./components/ExampleComponent.vue').default);
 
 /**
  * Next, we will create a fresh Vue application instance and attach it to
  * the page. Then, you may begin adding components to this application
  * or customize the JavaScript scaffolding to fit your unique needs.
  */
 
 const app = new Vue({
     el: '#vue-app',
     
     methods: {
        clickLine(url) {
            gtag_report_conversion(url);
        }
     },
     
 });
 
      
 // Defining event listener function
 function displayWindowSize(){
     // Get width and height of the window excluding scrollbars
     var w = document.documentElement.clientWidth;
     
     // Display result inside a div element
     // console.log("Width: " + w + ", " + "Height: " + h);
 
     $('.swiper-wrapper').height(w / 1920 * 800);
 }
     
 // Attaching the event listener function to window's resize event
 window.addEventListener("resize", displayWindowSize);
 
 // Calling the function for the first time
 displayWindowSize();